import { Menu } from "antd";
import Sider from "antd/es/layout/Sider";
import { useSelector } from "react-redux";
import { formatTitle } from "../../composants/utils/utils";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { 
    faArrowAltCircleRight, 
    faCertificate, 
    faSchool, 
    faGraduationCap,
    faChevronDown,
    faChevronRight,
    faHome,
    faBookOpen
} from "@fortawesome/free-solid-svg-icons";
import { useContext, useEffect, useState } from "react";
import { CollepsedContext } from "../../configurations/context/collepsedContext";
import axiosInstance from "../../configurations/axiosInstance/AxiosInstance";
import { ColorsContext } from "../../configurations/context/colorContext";

export const CustomSiderBar = () => {
    const {collespsed} = useContext(CollepsedContext);
    const {colors} = useContext(ColorsContext);
    const { accessToken } = useSelector(state => state.authUser);
    const [categories, setCategories] = useState([]);

    const fetchAllCategories = ()=>{
        setCategories([]);
        
        // Sous-menus pour Formations
        const formationSubMenus = [
            getItem(
                <Link to="/" title='Toutes les formations' className="flex items-center gap-2 text-gray-600 hover:text-green-600 transition-colors duration-300">
                    <span>Toutes les formations</span>
                </Link>, 
                'all-formations', 
                <FontAwesomeIcon icon={faBookOpen} className="text-sm" />
            ),
        ];

        // Récupérer les catégories depuis l'API
        axiosInstance(accessToken).get(
            "api/categorie/list"
        ).then((result)=> {
            // Ajouter chaque catégorie comme sous-menu
            result.data.forEach((element, index) => {
                formationSubMenus.push(
                    getItem(
                        <Link 
                            to={"/list/"+element.code} 
                            title={element.description}
                            className="flex items-center gap-2 text-gray-600 hover:text-green-600 transition-colors duration-300"
                        >
                            <span>{formatTitle(element.description, 12)}</span>
                        </Link>,
                        `category-${element.code}`,
                        <FontAwesomeIcon icon={faGraduationCap} className="text-sm" />
                    )
                );
            });

            // Créer le menu Formation avec ses sous-menus
            const formationMenu = getItem(
                <span className="flex items-center gap-3 text-gray-700 font-medium">
                    <span>Formations</span>
                </span>,
                'formations',
                <FontAwesomeIcon icon={faSchool} className="text-lg" />,
                formationSubMenus
            );

            // Construire la liste finale des menus
            const finalMenus = [formationMenu];
            setCategories(finalMenus);
        }).catch((result)=> {
            const fallbackMenus = [];
            setCategories(fallbackMenus);
        });
    }


    function getItem(label, key, icon, children) {
            return {
              key,
              icon,
              children,
              label,
            };
          };
    useEffect(()=>{
        fetchAllCategories();
    },[]);

    return (
        <Sider 
            style={{backgroundColor: colors.COLOR_NAVBAR}}  
            trigger={null} 
            collapsible 
            collapsed={collespsed} 
            theme='light'
            className="fixed h-screen overflow-auto left-0 top-0 bottom-0 shadow-lg border-r border-gray-200"
        >
            {/* Logo Section */}
            <div className="relative overflow-hidden" style={{backgroundColor: colors.COLOR_HEADER}}>
                {!collespsed ? (
                    <div className="flex items-center justify-center h-16 px-4 bg-gradient-to-r from-green-500/10 to-blue-500/10">
                        <img 
                            src='/images/logo/logo.png' 
                            className='h-16 w-auto object-contain transition-transform duration-300 hover:scale-105' 
                            alt="YOUTHFP Logo"
                        />
                    </div>
                ) : (
                    <div className="flex items-center justify-center h-16 px-2 bg-gradient-to-r from-green-500/10 to-blue-500/10">
                        <img 
                            src='/images/logo/justlogo.png' 
                            className='h-16 w-auto object-contain transition-transform duration-300 hover:scale-105' 
                            alt="YOUTHFP Logo"
                        />
                    </div>
                )}
                {/* Decorative line */}
                <div className="h-1 bg-gradient-to-r from-green-500 to-blue-500"></div>
            </div>

            {/* Menu Section */}
            <div className="py-4">
                <style>{`
                    .ant-menu-item {
                        margin: 4px 8px !important;
                        border-radius: 8px !important;
                        transition: all 0.3s ease !important;
                    }
                    
                    .ant-menu-item:hover {
                        background: linear-gradient(135deg, #f0f9ff 0%, #ecfdf5 100%) !important;
                        transform: translateX(4px);
                        box-shadow: 0 2px 8px rgba(16, 185, 129, 0.15) !important;
                    }
                    
                    .ant-menu-item-selected {
                        background: linear-gradient(135deg, #10b981 0%, #3b82f6 100%) !important;
                        color: white !important;
                        box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3) !important;
                    }
                    
                    .ant-menu-item-selected a {
                        color: white !important;
                    }
                    
                    .ant-menu-submenu-title {
                        margin: 4px 8px !important;
                        border-radius: 8px !important;
                        transition: all 0.3s ease !important;
                    }
                    
                    .ant-menu-submenu-title:hover {
                        background: linear-gradient(135deg, #f0f9ff 0%, #ecfdf5 100%) !important;
                        transform: translateX(4px);
                    }
                    
                    .ant-menu-submenu-open > .ant-menu-submenu-title {
                        background: linear-gradient(135deg, #f0f9ff 0%, #ecfdf5 100%) !important;
                    }
                    
                    .ant-menu-sub {
                        background: transparent !important;
                    }
                    
                    .ant-menu-sub .ant-menu-item {
                        margin: 2px 16px 2px 24px !important;
                        padding-left: 16px !important;
                        border-left: 2px solid transparent;
                        color: black !important;
                    }
                    
                    .ant-menu-sub .ant-menu-item a {
                        color: black !important;
                    }
                    
                    .ant-menu-sub .ant-menu-item:hover {
                        border-left-color: #10b981;
                        background: linear-gradient(135deg, #f0fdf4 0%, #f0f9ff 100%) !important;
                        color: black !important;
                    }
                    
                    .ant-menu-sub .ant-menu-item:hover a {
                        color: black !important;
                    }
                    
                    .ant-menu-inline .ant-menu-item, 
                    .ant-menu-inline .ant-menu-submenu-title {
                        width: calc(100% - 16px);
                    }

                    /* Styles pour le menu collapsed */
                    .ant-menu-inline-collapsed .ant-menu-submenu-title {
                        padding: 0 calc(50% - 16px / 2) !important;
                    }

                    /* Popup submenu styles */
                    .ant-menu-submenu-popup {
                        background: white !important;
                        border-radius: 12px !important;
                        box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12) !important;
                        border: 1px solid #e5e7eb !important;
                        overflow: hidden !important;
                        z-index: 1050 !important;
                    }

                    .ant-menu-submenu-popup .ant-menu {
                        background: white !important;
                        border-radius: 12px !important;
                        padding: 8px !important;
                        box-shadow: none !important;
                    }

                    .ant-menu-submenu-popup .ant-menu-item {
                        margin: 4px 0 !important;
                        border-radius: 8px !important;
                        color: #000000 !important;
                        padding: 8px 16px !important;
                        background: white !important;
                        opacity: 1 !important;
                        visibility: visible !important;
                        display: flex !important;
                        align-items: center !important;
                    }

                    .ant-menu-submenu-popup .ant-menu-item a,
                    .ant-menu-submenu-popup .ant-menu-item a *,
                    .ant-menu-submenu-popup .ant-menu-item span,
                    .ant-menu-submenu-popup .ant-menu-item span *,
                    .ant-menu-submenu-popup .ant-menu-item > * {
                        color: #000000 !important;
                        font-weight: 500 !important;
                        opacity: 1 !important;
                        visibility: visible !important;
                        text-decoration: none !important;
                        display: inherit !important;
                    }

                    .ant-menu-submenu-popup .ant-menu-item:hover {
                        background: linear-gradient(135deg, #f0fdf4 0%, #f0f9ff 100%) !important;
                        color: #000000 !important;
                    }

                    .ant-menu-submenu-popup .ant-menu-item:hover a,
                    .ant-menu-submenu-popup .ant-menu-item:hover a *,
                    .ant-menu-submenu-popup .ant-menu-item:hover span,
                    .ant-menu-submenu-popup .ant-menu-item:hover span *,
                    .ant-menu-submenu-popup .ant-menu-item:hover > * {
                        color: #000000 !important;
                    }

                    /* Extra specificity for collapsed menu popup text */
                    .ant-layout-sider-collapsed .ant-menu-submenu-popup .ant-menu-item,
                    .ant-layout-sider-collapsed .ant-menu-submenu-popup .ant-menu-item a,
                    .ant-layout-sider-collapsed .ant-menu-submenu-popup .ant-menu-item span {
                        color: #000000 !important;
                        opacity: 1 !important;
                        visibility: visible !important;
                        font-size: 14px !important;
                    }

                    /* Force visibility for all text elements in popup */
                    .ant-menu-submenu-popup *,
                    .ant-menu-submenu-popup *::before,
                    .ant-menu-submenu-popup *::after {
                        opacity: 1 !important;
                        visibility: visible !important;
                        color: inherit !important;
                    }
                `}</style>
                
                <Menu 
                    style={{
                        backgroundColor: colors.COLOR_NAVBAR,
                        border: 'none'
                    }}  
                    theme="light" 
                    mode="inline" 
                    items={categories}
                    className="border-none custom-menu"
                    inlineCollapsed={collespsed}
                    triggerSubMenuAction="hover"
                />
            </div>

            {/* Footer Section */}
            {!collespsed && (
                <div className="absolute bottom-4 left-4 right-4">
                    <div className="bg-gradient-to-r from-green-50 to-blue-50 rounded-xl p-3 border border-green-100">
                        <div className="flex items-center gap-2 mb-2">
                            <FontAwesomeIcon icon={faGraduationCap} className="text-green-600" />
                            <span className="text-xs font-semibold text-gray-700">YOUTHFP</span>
                        </div>
                        <p className="text-xs text-gray-600 leading-relaxed">
                            Votre plateforme de formation en ligne
                        </p>
                    </div>
                </div>
            )}
        </Sider>
    );
}